// src/entities/DistributionBoard.js
import Symbol from "./Symbol";
import { INSPECTOR_DISTRIBUTION_BOARD } from "../../../constants/inspectorConstants";

class DistributionBoard extends Symbol {
  constructor({ alias, svgSrc, label, rotable, handles, name }) {
    super("DistributionBoard", { alias, svgSrc, label, rotable, handles, name });

    this.attributes = {
      ...this.attributes,

      internalid: {
        isVisible: false,
        value: null,
        label: "ID",
      },

      headerData: {
        isVisible: false,
        value: [],
        label: "Encabezados",
        systemModified: true
      },

      rowData: {
        isVisible: false,
        value: [],
        label: "Filas de datos",
        systemModified: true
      },

      columnWidths: {
        isVisible: false,
        value: [],
        label: "Anchos de columnas",
        systemModified: true
      },

      showDistributionBoardPreview: {
        isVisible: false,
        value: false,
        label: "Mostrar centro de cargas",
        systemModified: true
      },

      distributionBoardPreviewScale: {
        isVisible: false,
        value: 1,
        label: "Tamaño centro de cargas",
        systemModified: true
      },

      distributionBoardPreviewPosition: {
        isVisible: false,
        value: null,
        label: "Posición centro de cargas",
        systemModified: true
      }
    };
  }

  getInspector() {
    return INSPECTOR_DISTRIBUTION_BOARD;
  }
}

export default DistributionBoard;
